module.exports = __webpack_public_path__ + "static/img/hk_br.35eb58e3.jpg";